import {Page} from "../page";
import {DashboardView} from "../dashboardCard";
import {WithAPI} from "../../api/temperature";
import {useFetchAndRender} from "../fetchAndRender";
import {Dropdown} from "../generic/dropdown";
import {route} from "preact-router";
import {AsRoute} from "../../app";
import {SensorSet} from "../../api/set";
import {Title} from "../header";
import {PopupMenu} from "../generic/menu";
import {Error404} from "../error";

type WithSetID = { setId?: number };
type WithSet = { set: SensorSet };

export type DashboardProps = (WithSet | WithSetID) & WithAPI & AsRoute;

export function Dashboard(props: DashboardProps) {
    const [result] = useFetchAndRender<SensorSet[]>(async () =>
        (await props.api.sets.get()).sensor_sets,
        {interval: 0}
    );

    const renderTitle = (title: string) => {
        let options = [];

        for (const set of result ?? []) {
            options.push(<li><a href={set.url} onClick={(e) => {e.preventDefault(); route(e.currentTarget.href, true);}}>{set.name}</a></li>);
        }

        return <>
            <Dropdown
                content={<PopupMenu>{options}</PopupMenu>}
                position={"bottom"}
            >
                <Title>{title}</Title>
            </Dropdown>
        </>;
    }

    let readySet;

    if ((props as WithSetID).setId) {
        const [set] = useFetchAndRender<SensorSet>(async () => {
            return (await props.api.sets.get({filter: { ids: [(props as WithSetID).setId ?? 0 ]}})).sensor_sets[0] ?? null;
        })
        readySet = set;
    } else {
        readySet = (props as WithSet).set;
    }

    if (readySet === undefined) {
        return null;
    }

    if (readySet === null) {
        return <Error404 />
    }

    return <Page
        showBackButton={true}
        title={readySet.name}
        titleMarkup={(title) => renderTitle(title)}
    >
        <DashboardView set={readySet} api={props.api} />
    </Page>;
}
